// getUrlTimecode.js
'use strict';
import { createSelector } from '../resource/createCachedSelector.js';

import getRouterData from '../selector/getRouterData.js';
import { selectorError } from '../resource/debug.js';

/**
 * Parse timecode.
 * @param {string} timecode - video timecode.
 * @return {number} return video timecode in seconds if parse successfully.
 */
const parseTimecode = timecode => {
  try {
    const isInterger = Number.isInteger(+timecode);
    if (isInterger) {
      return +timecode;
    }
    // example: 1h2m3s
    const formatReg = /(\d+h)?(\d+m)?(\d+s)?/i;
    const formatExecResult = formatReg?.exec(timecode);
    if (formatExecResult) {
      const hour = +formatExecResult[1]?.replace(/h/i, '') || 0;
      const minute = +formatExecResult[2]?.replace(/m/i, '') || 0;
      const second = +formatExecResult[3]?.replace(/s/i, '') || 0;
      return 60 * 60 * hour + 60 * minute + second;
    }
    return 0;
  } catch (error) {
    selectorError('error occured at selector/getUrlTimecode.js', error);
    return 0;
  }
};
/**
 * Select timecode by router
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @return {number} return parsed timecode from `location.search`.
 */
const getUrlTimecode = createSelector(
  state => getRouterData(state, 'location.search'),
  (search = '') => {
    const searchObj = new URLSearchParams(search || '');
    const timecode = searchObj.get('t');
    if (timecode === null) {
      return 0;
    }
    const result = parseTimecode(timecode);
    return result;
  }
);

export default getUrlTimecode;
